import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Radio } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import DropdownList from 'components/controls/DropdownList';
import { routesAdmin } from 'routes/Routes';
import { GENERAL_ERROR_MESSAGE, ROOT_PATH } from 'constants/constants';
import FileUpload from '../../components/controls/FileUpload';
import xls from '../../assets/template/BankTxnFileTemplate.xlsx';
import _authService from '../../modules/AuthService';

class ExportPhotoSignature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            post: 0,
            photo: true,
            exams: [],
            loading: false,
        };
    }

    componentDidMount() {
        this.getAllExams();
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleDownload = async (input) => {
        //console.log("reached: ", this.state);

        if (this.state.post == 0) {
            _notification.showMessage('error', "Please select Post/Exam.");
            return;
        }
       
        try {
            this.setState({ loading: true }, async () => {
                try {

                    const response = await _AdminService.GetPhotoSignatureData(this.state.post, this.state.photo);
                    console.log("File response: ", response.data);
                    if (response.status == 200) {
                        //console.log('Final URL: ', _AdminService.GetAttendanceURL(response.data));

                        // let alink = document.createElement('a');
                        // alink.href = _AdminService.GetAttendanceURL(response.data);
                        // alink.download = response.data;
                        // alink.click();

                        _notification.showMessage('success', "Download Request submitted successfully. Please contact admin to get downloaded files.");
                        this.setState({
                            loading: false,
                            //post: "",
                            //status: 0,
                        });
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    onPostChange = (event) => {
        this.setState({
            ...this.state,
            post: event.target.value
        });
    }

    onGenderChange = (event) => {
        this.setState({
            photo: !this.state.photo,
        });
    }

    render() {

        if (this.state.loading)
            return <LoadingSpinner />

        return (

            <div className="container-fluid p-3">
                <div className="max1200 m-auto">
                    <PageHeader
                        title="Export Candidate Photo & Signature"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Reports' }, { label: 'Export Photo & Signature' }]}
                    />
                    <div className="ent-panel mb-3">
                        <div className="admin-inner-wrap p-3">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <DropdownList
                                        value={this.state.post}
                                        name="ParentId"
                                        onChange={this.onPostChange}
                                        placeholder="Select Post"
                                        heading={"Post/Exam"}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        options={this.state.exams}
                                    // errorState={this.state.degreeError}
                                    // errorMessage={this.state.degreeError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <Radio.Group className="d-flex pt-3 mb-sm-4 mt-sm-4" onChange={this.onGenderChange}
                                        value={this.state.photo ? 0 : 1}>
                                        <Radio value={0} style={{ display: 'flex' }}>
                                            <label className="card-holder-name mr-2">Photo</label>
                                        </Radio>
                                        <Radio value={1} style={{ display: 'flex' }}>
                                            <label className="card-holder-name mr-2">Signature</label>
                                        </Radio>
                                    </Radio.Group>
                                </div>
                            </div>
                        </div>
                        <div className="pt-4 buttonAlignCenter" >
                            <button type="button" onClick={this.handleDownload} className="button-global button-primary autoHeight autoWidth"><span>Download {this.state.photo ? "Pohto" : "Signature"}</span></button>
                        </div>
                    </div>

                    <div className="note-wrap gl-bxbr p-3">
                        <h6 className="note-heading">Note:</h6>
                        <label>Download Pohto/Signature process takes a long time. Please contact admin to get downloaded files from server. </label>
                    </div>    

                </div> 
            </div>
        )
    };
}

export default ExportPhotoSignature;